import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import { DialogIntro } from '../../../components/Containers/Dialog/DialogIntro';
import { usePreAuthDrawCtx } from '../../../providers/PreAuthDrawProvider';

export const IntroStep: FC = () => {
  const { t } = useTranslation('product');
  const { dispatchDate } = usePreAuthDrawCtx();

  return (
    <DialogIntro
      buttonText={t('preOrder.intro.cta')}
      content={[
        {
          description: t('preOrder.intro.payment.description'),
          icon: 'ic_credit_card',
          title: t('preOrder.intro.payment.title'),
        },
        {
          description: t('preOrder.intro.review.description'),
          icon: 'ic_schedule',
          title: t('preOrder.intro.review.title'),
        },
        {
          description: t('preOrder.intro.dispatch.description'),
          icon: 'ic_shipping',
          title: t('dispatchDate.schedule.range', {
            range: dispatchDate.range,
          }),
        },
      ]}
    />
  );
};
